import { Component } from '@angular/core';
import { RouterLinkWithHref, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { RequirePermissionsDirective } from '../../directives/require-permissions/require-permissions.directive';
import { IconComponent } from '../icon/icon.component';
import { ProfileComponent } from '../profile/profile.component';
import { AboutComponent } from '../about/about.component';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { navigationRoutes, type NavigationRoute } from './navigation.service';

@Component({
  selector: 'dpqa-navigation',
  imports: [
    RouterLinkWithHref,
    RouterLinkActive,
    IconComponent,
    TranslatePipe,
    ProfileComponent,
    RequirePermissionsDirective,
    AboutComponent,
    NzDividerComponent,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.less',
})
export class NavigationComponent {
  protected routes: NavigationRoute[] = navigationRoutes;
}
